export default "__VITE_ASSET__BdXxsxmc__"